import React from 'react';
import ResultadoListaPartidos from '../consulta/ResultadoListaPartidos.js';
import { NombreEquipoCategoria, NombreEquipoTorneo } from '../funciones/FuncionesEquipo.js';
import * as Funciones from '../funciones/FuncionesPartidos.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import styles from './PartidosEtapaTorneo.module.css';

const PartidosEtapaTorneo = (props) => {
  const categoria = props.categoria;
  const torneo = props.torneo;
  const partidos = props.partidos;
  const etapa = props.etapa;

  const onPartidoElegido = (idPartido) => {
    props.onPartidoElegido(idPartido);
  };

  let partidosVisibles = [];
  let equiposLibres = [];
  if (partidos) {
    for (const partido of partidos) {
      if (partido.equipoLibre) {
        const nombreLocal =
          partido.equipoLocal && partido.equipoLocal.nombre
            ? partido.equipoLocal.nombre
            : 'Equipo desconocido';
        equiposLibres = [...equiposLibres, nombreLocal];
      } else {
        partidosVisibles = [...partidosVisibles, partido];
      }
    }
  }

  // Verificar si la etapa tiene fechas
  const etapaTieneFechas = etapa && etapa.cantidadFechas && etapa.cantidadFechas > 0;

  // Si no tiene fechas, verificar si hay zonas o instancias
  let partidosPorGrupo = {};
  let grupos = [];
  let tipoAgrupacion = null; // 'zona' o 'instancia'

  if (!etapaTieneFechas && partidosVisibles.length > 0) {
    // Verificar si hay zonas
    const tieneZonas = partidosVisibles.some((partido) => partido.zona && partido.zona !== '-');

    if (tieneZonas) {
      // Agrupar por zona
      tipoAgrupacion = 'zona';
      partidosVisibles.forEach((partido) => {
        const zona = partido.zona || 'sin-zona';
        if (!partidosPorGrupo[zona]) {
          partidosPorGrupo[zona] = [];
          grupos.push(zona);
        }
        partidosPorGrupo[zona].push(partido);
      });

      // Ordenar zonas: alfabéticamente, pero 'X' (Interzonal) al final y 'sin-zona' al final
      grupos.sort((a, b) => {
        // sin-zona siempre al final
        if (a === 'sin-zona') return 1;
        if (b === 'sin-zona') return -1;
        // X (Interzonal) después de las zonas normales pero antes de sin-zona
        if (a === 'X') return 1;
        if (b === 'X') return -1;
        // Ordenamiento alfabético normal
        return a.localeCompare(b);
      });
    } else {
      // Agrupar por instancia
      tipoAgrupacion = 'instancia';
      partidosVisibles.forEach((partido) => {
        const instancia = partido.instancia || 'Unico';
        if (!partidosPorGrupo[instancia]) {
          partidosPorGrupo[instancia] = [];
          grupos.push(instancia);
        }
        partidosPorGrupo[instancia].push(partido);
      });
    }
  }

  // Función para obtener el título del grupo
  const obtenerTituloGrupo = (grupo, tipo) => {
    if (tipo === 'zona') {
      if (grupo === 'sin-zona' || grupo === '-') return null;
      if (grupo === 'X') return 'Interzonal';
      return `Zona ${grupo}`;
    }
    // Para instancia
    if (grupo === 'Unico') return null;
    return grupo;
  };

  // Función para renderizar una tabla de partidos
  const renderTablaPartidos = (partidosGrupo, mostrarFecha, tituloGrupo = null) => (
    <React.Fragment>
      {tituloGrupo && <div className={`${styles.tituloInstancia}`}>{tituloGrupo}</div>}
      <table className={`${styles.tabla_partidos}`}>
        <thead>
          <tr>
            {mostrarFecha && <th>Fec.</th>}
            <th>Día</th>
            <th>Local</th>
            <th>Result</th>
            <th>Visitante</th>
          </tr>
        </thead>
        <tbody>
          {partidosGrupo.map((partido) => (
            <tr key={partido.id}>
              {mostrarFecha && (
                <td className={`${styles.nroFecha}`}>
                  {Funciones.DetalleFecha(partido.nroFecha, partido.instancia)}
                </td>
              )}
              <td className={`${styles.fecha}`}>
                {FuncionesFecha.CamposToFechaCorta(
                  partido.anioPartido,
                  partido.mesPartido,
                  partido.diaPartido
                )}
              </td>
              <td className={`${styles.equipo}`}>
                {torneo
                  ? NombreEquipoTorneo(partido.equipoLocal, torneo)
                  : NombreEquipoCategoria(
                      partido.equipoLocal.nombre,
                      partido.equipoLocal.categoria,
                      categoria
                    )}
              </td>
              <td className={`${styles.result}`}>
                <ResultadoListaPartidos
                  id={partido.id}
                  onPartidoElegido={onPartidoElegido}
                  local={partido.resultadoLocal}
                  visitante={partido.resultadoVisitante}
                />
              </td>
              <td className={`${styles.equipo}`}>
                {torneo
                  ? NombreEquipoTorneo(partido.equipoVisitante, torneo)
                  : NombreEquipoCategoria(
                      partido.equipoVisitante.nombre,
                      partido.equipoVisitante.categoria,
                      categoria
                    )}
              </td>
            </tr>
          ))}
          {equiposLibres &&
            equiposLibres.map((nombre, index) => (
              <tr key={`libre-${index}`}>
                <td colSpan={mostrarFecha ? '5' : '4'} className={`${styles.equipo}`}>
                  {`Libre: ${nombre}`}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {etapaTieneFechas || grupos.length === 0 ? (
        // Si tiene fechas o no hay grupos, mostrar tabla normal con columna Fec.
        renderTablaPartidos(partidosVisibles, true)
      ) : grupos.length === 1 && obtenerTituloGrupo(grupos[0], tipoAgrupacion) === null ? (
        // Si solo hay un grupo sin título (Unico o sin-zona), mostrar sin columna Fec. y sin título
        renderTablaPartidos(partidosVisibles, false)
      ) : (
        // Si hay múltiples grupos, mostrar una tabla por cada grupo
        <div className={`${styles.contenedorInstancias}`}>
          {grupos.map((grupo) => (
            <div key={grupo} className={`${styles.grupoInstancia}`}>
              {renderTablaPartidos(
                partidosPorGrupo[grupo],
                false,
                obtenerTituloGrupo(grupo, tipoAgrupacion)
              )}
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default PartidosEtapaTorneo;
